import { _ } from "../../core/polyglot/polyglot.js";
import { eyeIcon } from "../../core/elements/icons/index.js";
import { widget } from "@foretagsplatsen/widgetjs";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner
import selection from "../../models/accounting/document/selection.js";
import updatingTitleWidget from "./updatingTitleWidget.js";

/**
 * `editPreliminaryDocumentsWidget` is a widget to mark preliminary documents
 * as permanent from company settings.
 *
 * @param {number} spec.companyId - Identifier of the company whose document archive is visible
 */
export default widget.subclass((that, my) => {
	my.initialize = function ({ companyId }) {
		my.super(...arguments);
		my.documents = [];
		my.loaded = false;
		my.companyId = companyId;
	};

	my.initializeSubwidgets = function (spec) {
		my.super(spec);

		my.updatingTitleWidget = updatingTitleWidget({
			title: () => {},
		});

		// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
		my.spinnerWidget = new OldSpinnerWidget({
			dark: true,
		});
	};

	that.onMarkDocument = my.events.createEvent();
	that.onMarkAllDocuments = my.events.createEvent();

	that.setDocuments = function (newDocuments) {
		my.documents = newDocuments.sort((a, b) =>
			a.name() < b.name() ? -1 : 1,
		);

		my.loaded = true;

		that.update();
	};

	that.renderContentOn = function (html) {
		html.render(my.updatingTitleWidget);
		if (my.loaded) {
			if (my.documents.length) {
				my.renderContentOn(html);
			} else {
				my.renderEmptyOn(html);
			}
		} else {
			my.renderLoadingOn(html);
		}
	};

	my.renderEmptyOn = function (html) {
		html.render(
			_(
				"There are no preliminary documents. If you want to add preliminary documents, please visit the {link: Documents} page.",
				{
					link: function (pageName) {
						return function (html) {
							html.a(
								{
									href: my.router.linkTo("document-archive", {
										// Passing the companyId is a hack to
										// be able to use this widget in
										// Agency2 as well. This should be
										// fixed by FTGP-5174.
										companyId: my.companyId,
									}),
								},
								pageName,
							);
						};
					},
				},
			),
		);
	};

	my.renderLoadingOn = function (html) {
		html.div(my.spinnerWidget);
	};

	my.renderContentOn = function (html) {
		html.div(
			{ klass: "list-stripped" },
			html.ul(my.documents.map(documentRenderer)),
		);

		html.div(
			{
				klass: "pull-right",
			},
			html
				.a(
					{
						klass: "btn btn-primary",
					},
					_("Mark all as permanent"),
				)
				.click(() => {
					const documentSelection = selection.model({
						items: my.documents.slice(),
					});
					my.updatingTitleWidget.pend();

					that.onMarkAllDocuments.trigger(
						documentSelection,
						my.updatingTitleWidget.succeed,
					);
				}),
		);
	};

	function documentRenderer(document) {
		return function (html) {
			html.li(
				document.name(),
				html
					.div(
						{
							klass: "mark-permanent pull-right",
							title: _("Mark as permanent"),
						},
						eyeIcon,
					)
					.click(() => {
						my.updatingTitleWidget.pend();

						that.onMarkDocument.trigger(
							document,
							my.updatingTitleWidget.succeed,
						);
					}),
			);
		};
	}
});
